module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 83);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/component");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ button_Button; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(4);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(5);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(8);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(6);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(9);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@tencent/txv-utils"
var txv_utils_ = __webpack_require__(1);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/component"
var component_ = __webpack_require__(12);
var component_default = /*#__PURE__*/__webpack_require__.n(component_);

// CONCATENATED MODULE: ./src/comps/common/button/template.js
var buttonTpl = function buttonTpl(ops) {
  var className = ops.className,
    text = ops.text,
    type = ops.type,
    size = ops.size,
    disabled = ops.disabled,
    loading = ops.loading,
    round = ops.round;
  var disabledAttr = disabled || loading ? 'disabled' : '';
  return "\n    <button\n      class=\"mod-btn\n      ".concat(className, "\n      ").concat(type ? "mod-btn--".concat(type) : '', "\n      ").concat(size ? "mod-btn--".concat(size) : '', "\n      ").concat(loading ? 'is-loading' : '', "\n      ").concat(disabled ? 'disabled' : '', "\n      ").concat(round ? 'is-round' : '', "\"\n      ").concat(disabledAttr, ">\n      ").concat(loading ? '<i class="mod-icon-loading"></i>' : '', "\n      ").concat(text, "\n    </button>\n  ");
};
/* harmony default export */ var template = (buttonTpl);
// CONCATENATED MODULE: ./src/comps/common/button/index.js





function _callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @Author ivytang
 * @Date 2020/1/11
 * @Desc 按钮公共组件
 * @Param {String} [size] - 尺寸 oversize / medium / small
 * @Param {String} [type] - 类型 默认primary实心按钮 / 其余目前hollow空心按钮
 * @Param {Boolean} [round] - 是否圆角按钮
 * @Param {Boolean} [loading] - 是否加载中状态
 * @Param {Boolean} [disabled] - 是否禁用状态
 * @Param {String} [text] - 按钮内容
 * @Param {String} [className] - 自定义class
 **/



var button_Button = /*#__PURE__*/function (_Component) {
  function Button(containerId, options) {
    var _this;
    classCallCheck_default()(this, Button);
    _this = _callSuper(this, Button, [containerId, options]);
    _this.eventHub = txv_utils_["EventHub"].createEvents(_this);
    _this.initAction();
    _this.action();
    return _this;
  }
  inherits_default()(Button, _Component);
  return createClass_default()(Button, [{
    key: "initAction",
    value: function initAction() {
      var _this2 = this;
      this.action = Object(txv_utils_["once"])(function () {
        _this2.$renderDom.on('click', function (e) {
          _this2.eventHub.fire('button-click', e.target);
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$options = this.options,
        _this$options$size = _this$options.size,
        size = _this$options$size === void 0 ? 'medium' : _this$options$size,
        _this$options$round = _this$options.round,
        round = _this$options$round === void 0 ? true : _this$options$round,
        _this$options$disable = _this$options.disabled,
        disabled = _this$options$disable === void 0 ? false : _this$options$disable,
        _this$options$type = _this$options.type,
        type = _this$options$type === void 0 ? 'primary' : _this$options$type,
        loading = _this$options.loading,
        _this$options$text = _this$options.text,
        text = _this$options$text === void 0 ? '' : _this$options$text,
        _this$options$classNa = _this$options.className,
        className = _this$options$classNa === void 0 ? '' : _this$options$classNa;
      return template({
        size: size,
        type: type,
        round: round,
        loading: loading,
        disabled: disabled,
        text: text,
        className: className
      });
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.$renderDom.html();
    }
  }, {
    key: "setValue",
    value: function setValue(val) {
      return this.$renderDom.html(val);
    }
  }]);
}(component_default.a);


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ })

/******/ })["default"];